import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/auth.store';
import { ROUTES } from './routes';
// Requires authentication — redirects to /login with returnTo so the login page
// sends the user back to the page they were trying to reach after they sign in.
export function ProtectedRoute() {
    const { isAuthenticated } = useAuthStore();
    const location = useLocation();
    if (!isAuthenticated) {
        return (_jsx(Navigate, { to: ROUTES.LOGIN, state: { returnTo: location.pathname + location.search }, replace: true }));
    }
    return _jsx(Outlet, {});
}
// Only for unauthenticated users — redirects logged-in users away from login/register
export function PublicOnlyRoute() {
    const { isAuthenticated } = useAuthStore();
    if (isAuthenticated)
        return _jsx(Navigate, { to: ROUTES.HOME, replace: true });
    return _jsx(Outlet, {});
}
export function RoleRoute({ role }) {
    const { isAuthenticated, user } = useAuthStore();
    if (!isAuthenticated)
        return _jsx(Navigate, { to: ROUTES.LOGIN, replace: true });
    if (!user?.roles.includes(role))
        return _jsx(Navigate, { to: ROUTES.UNAUTHORIZED, replace: true });
    return _jsx(Outlet, {});
}
//# sourceMappingURL=ProtectedRoute.js.map